import { createContext } from 'react'

interface IOrderHistoryContext {
  order: OrderTrackingItem | undefined
  loading: boolean
}

const OrderHistoryContext = createContext<IOrderHistoryContext>({
  order: undefined,
  loading: false,
})

export default OrderHistoryContext
